namespace SorAraBul.Definitions {
    export interface TownsRow {
        Id?: number;
        Name?: string;
        CityId?: number;
        CityName?: string;
        CityCountryId?: number;
        CountryName?: string;
    }

    export namespace TownsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Definitions.Towns';
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = '*';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            CityId = "CityId",
            CityName = "CityName",
            CityCountryId = "CityCountryId",
            CountryName = "CountryName"
        }
    }
}
